import React from "react";
import { Wrench, Crown, Layers, ArrowRight } from "lucide-react";
import { prices } from "../data";

const PriceIcon = ({ type }) => {
  if (type === "implant") return <Wrench size={28} strokeWidth={1.6} />;
  if (type === "crown") return <Crown size={28} strokeWidth={1.6} />;
  return <Layers size={28} strokeWidth={1.6} />;
};

// Привязки для флагов и иконок (по названию)
const detectType = (title) => {
  const t = title.toLowerCase();
  if (t.includes("коронка")) return "crown";
  if (t.includes("под ключ")) return "turnkey";
  return "implant";
};

// Страна изготовителя (оффер)
const detectOrigin = (title) => {
  const t = title.toLowerCase();
  if (t.includes("osstem")) return { flag: "🇰🇷", country: "Корея · Osstem" };
  if (t.includes("коронка")) return { flag: "🇷🇺", country: "Россия · своя лаборатория" };
  if (t.includes("под ключ")) return { flag: "🇰🇷", country: "Корея · Osstem + цирконий" };
  return null;
};

export default function Prices() {
  return (
    <section className="prices" id="prices">
      <div className="container">
        <div className="section-label">Прозрачные цены</div>
        <h2 className="section-title">Честная стоимость имплантации зубов</h2>
        <p className="section-subtitle">
          Никаких скрытых доплат. На консультации вы получите подробную смету, которую мы согласуем до начала лечения.
        </p>

        <div className="prices-grid">
          {prices.map((p) => {
            const type = detectType(p.title);
            const origin = detectOrigin(p.title);
            return (
              <div
                key={p.title}
                className={`price-card ${p.popular ? "popular" : ""}`}
                data-testid={`price-${p.title}`}
              >
                {p.popular && <div className="price-badge">Выгоднее всего</div>}

                <div className="price-head">
                  {type === "implant" && (
                    <div className="price-type-photo" data-testid="price-photo-implant">
                      <img src="/products/osstem.jpg" alt="Имплант Osstem" loading="lazy" />
                    </div>
                  )}
                  {type === "crown" && (
                    <div className="price-type-photo" data-testid="price-photo-crown">
                      <img src="/products/crown-zirconia.svg" alt="Циркониевая коронка" loading="lazy" />
                    </div>
                  )}
                  {type === "turnkey" && (
                    <div className="price-type-icon"><PriceIcon type={type} /></div>
                  )}
                  {origin && (
                    <div className="price-origin" data-testid={`price-origin-${type}`}>
                      <span className="price-flag" aria-hidden="true">{origin.flag}</span>
                      <span>{origin.country}</span>
                    </div>
                  )}
                </div>

                <div className="price-title">{p.title}</div>

                <div className="price-amount">
                  <span className="price-old">{p.old} ₽</span>
                </div>
                <div className="price-amount">
                  <span className="price-now">{p.now}</span>
                  <span className="price-curr">₽</span>
                </div>
                <p className="price-desc">{p.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="prices-cta">
          <a href="#final" className="btn btn-primary" data-testid="prices-cta">
            Получить консультацию
            <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
}
